import { UserRole } from './types';

export const getRoleDisplayName = (role: UserRole | undefined | null): string => {
  if (!role) return 'Member';
  
  const roleMap: Record<UserRole, string> = {
    admin: 'Administrator',
    manager: 'Manager',
    sales: 'Sales Representative',
    member: 'Member'
  };
  
  return roleMap[role] || 'Member';
};

export const getRoleBadgeColor = (role: UserRole | undefined | null): string => {
  if (!role) return 'bg-muted text-muted-foreground';
  
  const colorMap: Record<UserRole, string> = {
    admin: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300',
    manager: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
    sales: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
    member: 'bg-muted text-muted-foreground'
  };
  
  return colorMap[role] || 'bg-muted text-muted-foreground';
};
